// One fill for every usage meter on the AI settings pages: neutral while there
// is room, amber near the ceiling, red only where AI actually stops.
export function usageFillClass({
	percent,
	stops,
}: {
	percent: number
	stops: boolean
}): string {
	if (stops && percent >= 100) return "bg-red-500"
	if (percent >= 80) return "bg-amber-500"
	return "bg-gray-800 dark:bg-gray-300"
}
